"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 *
 *
 * @param {Recover} recover An reference to the Recover class
 * @param {number} debtId A reference to a single debt
 * @class DebtActions
 * @classdesc Handles all actions that can be performed on a debt by both Admins and Customers
 */
var DebtActions = /** @class */ (function () {
    function DebtActions(recover, debtId) {
        var _this = this;
        this.recover = recover;
        this.debtId = debtId;
        /**
         *
         *
         * @memberof DebtActions
         * @returns {SuccessfulIndexActions} Returns a message and an array of a single debts actions
         * @description Returns an index of all actions of a single debt
         */
        this.index = function () {
            return _this.recover.request("/debts/" + _this.debtId + "/actions", 'GET', null, null);
        };
        /**
         *
         *
         * @memberof DebtActions
         * @returns {SuccessfulTriggerAction} Returns a message and details of the debt affected
         * @property {ActionTypes} action_type A string value that can be submit, revert, stage_1, stage_2, pause, resume, close, resolve, decline, escalate
         * @property {ActionReason} reason A JSON object containing a fields called reason(string)
         * @description Allows admins to commit actions
         */
        this.admin = function (action_type, reason) {
            return _this.recover.request("/debts/" + _this.debtId + "/admin_action/" + action_type, 'PUT', reason, null);
        };
        /**
         *
         *
         * @memberof DebtActions
         * @returns {SuccessfulTriggerAction} Returns a message and details of the debt affected
         * @property {ActionTypes} action_type A string value that can be submit, revert, stage_1, stage_2, pause, resume, close, resolve, decline, escalate
         * @property {ActionReason} reason A JSON object containing a fields called reason(string)
         * @description Allows customers to commit actions
         */
        this.customer = function (action_type, body) {
            return _this.recover.request("/debts/" + _this.debtId + "/customer_action/" + action_type, 'PUT', body, null);
        };
    }
    return DebtActions;
}());
exports.default = DebtActions;
